import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { servicesList, featuredServiceIds } from '@/mocks/services';

export default function FeaturedServices() {
  const { t } = useTranslation();
  const featured = servicesList.filter((s) => featuredServiceIds.includes(s.id));

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-flex items-center gap-1.5 bg-blue-50 text-blue-700 text-xs font-semibold px-3 py-1.5 rounded-full mb-3">
            <i className="ri-tools-line text-xs"></i>
            {t('services.badge')}
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Van&apos;da <span className="text-blue-600">Su Kaçağı Tespiti, Tıkanıklık Açma ve Kombi Servisi</span>
          </h2>
          <p className="text-gray-500 text-sm md:text-base max-w-lg mx-auto">{t('services.subtitle')}</p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {featured.map((svc) => (
            <div key={svc.id} className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-blue-200 transition-all flex flex-col">
              {/* Image — tıklanabilir */}
              <Link to={`/hizmetler/${svc.slug}`} className="w-full h-48 sm:h-44 overflow-hidden shrink-0 block cursor-pointer">
                <img
                  src={svc.image}
                  alt={t(`svc.${svc.id}.title`)}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </Link>
              {/* Content */}
              <div className="p-4 sm:p-4 flex flex-col flex-1">
                {/* Icon + Title */}
                <div className="flex items-center gap-3 mb-3">
                  <span className="w-10 h-10 shrink-0 flex items-center justify-center bg-blue-50 rounded-xl">
                    <i className={`${svc.icon} text-blue-600 text-lg`}></i>
                  </span>
                  <h3 className="font-bold text-gray-900 text-sm leading-snug" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    {t(`svc.${svc.id}.title`)}
                  </h3>
                </div>
                {/* Description */}
                <p className="text-gray-500 text-sm leading-relaxed mb-4 flex-1">
                  {t(`svc.${svc.id}.desc`)}
                </p>
                {/* Call + WA buttons */}
                <div className="flex gap-2 mb-2">
                  <a
                    href="tel:+905076074165"
                    className="flex-1 flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-sm font-bold py-3 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-phone-fill"></i>
                    Hemen Ara
                  </a>
                  <a
                    href={svc.waUrl}
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="w-11 h-11 shrink-0 flex items-center justify-center bg-green-500 hover:bg-green-600 active:bg-green-700 text-white rounded-xl transition-colors cursor-pointer"
                    title="WhatsApp"
                  >
                    <i className="ri-whatsapp-line text-lg"></i>
                  </a>
                </div>
                {/* Detaylı Bilgi */}
                <Link
                  to={`/hizmetler/${svc.slug}`}
                  className="flex items-center justify-center gap-2 border border-blue-200 text-blue-600 hover:bg-blue-50 text-sm font-bold py-2.5 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-information-line"></i> Detaylı Bilgi
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* View All */}
        <div className="text-center mt-8">
          <Link
            to="/hizmetler"
            className="inline-flex items-center gap-2 border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white font-bold text-sm px-8 py-3 rounded-xl transition-all cursor-pointer whitespace-nowrap"
          >
            Tüm Hizmetleri Gör
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
